import { render, staticRenderFns } from "./FilesEdit.vue?vue&type=template&id=086c4594&"
import script from "./FilesEdit.vue?vue&type=script&lang=js&"
export * from "./FilesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports